/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.schools.districts'},
});

const DistrictsItem = () => (
  <RouteLinkItem
    route="midas/settings/schools/districts"
    title={messages.title}
  />
);

export default DistrictsItem;
